/**
 * Popover — всплывающая панель (Radix Popover). Наш стиль: arrow-const +
 * ref-проп. Используется для дропдаунов-фильтров (Статус/Тип/Тариф/Город).
 */

import type {ComponentPropsWithoutRef, ComponentRef, Ref} from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import {cn} from '@lib/utils';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

type ContentProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  ref?: Ref<ComponentRef<typeof PopoverPrimitive.Content>>;
};

export const PopoverContent = ({
  className,
  align = 'start',
  sideOffset = 6,
  ref,
  ...props
}: ContentProps) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-72 rounded-xl border bg-popover p-1.5 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
);
